import { Card, CardContent, Grid, Skeleton } from '@mui/material'
import React from 'react'

export default function NewpaymentSkeleton() {
    return (
        <Grid container padding={"20px"} spacing={2}>
            {[...Array(2)].map((_, index) => (
                <Grid item xs={12} key={index}>
                    <Card
                        variant="outlined"
                        sx={{
                            borderColor: '#e0e0e0',
                            p: 2,
                            borderRadius: 2,
                        }}
                    >
                        <CardContent sx={{ paddingBottom: '8px !important' }}>
                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Skeleton variant="circular" width={30} height={30} />
                                </Grid>
                                <Grid item xs={10}>
                                    <Skeleton variant="text" width="60%" height={24} />
                                    <Skeleton variant="text" width="60%" height={18} />
                                </Grid>
                            </Grid>

                            <Grid container mt={2} spacing={2}>
                                {[1, 2, 3].map((i) => (
                                    <Grid key={i} item xs={12} md={3}>
                                        <Skeleton variant="text" width="40%" height={18} />
                                        <Skeleton variant="text" width="80%" height={22} />
                                    </Grid>
                                ))}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    )
}
